function getView() {
  let DictCtxView = {
    model: "melhous.recommendation",
    form_action: ["edit", "add", "save"],
    table_action: ["edit", "add", "delete"],
    activeSearch: false,
    target: "melhous",
    autoSave: true,
    domain: [],
    fields: {
      name: { type: "char", required: true },
      message: { type: "char" },
      trigger_category: { type: "many2one", model: "product.category" },
      trigger_product: { type: "many2one", model: "product.template" },
      active: { type: "boolean" },
      sequence: { type: "integer" },
    },
    list: [{ name: "name" }, { name: "message" }, { name: "active" }],
    form: [
      { name: "name" },
      { name: "message" },
      { name: "trigger_category" },
      { name: "trigger_product" },
      { name: "sequence" },
      { name: "active" },
    ],
  };

  return DictCtxView;
}

export default { ctxView: getView };
